module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/payment-config-view/payment-config-view.component.css
// module id = ./src/app/finance/payment-config-view/payment-config-view.component.css
// module chunks = main